import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue";
import { onMounted, ref } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'FullScreenBtn',
    setup: function (__props) {
        var isFullScreen = ref(false);
        // 切换全屏模式
        var toggleFullScreen = function () {
            if (isFullScreen.value) {
                exitFullScreen();
            }
            else {
                enterFullScreen();
            }
        };
        // 进入全屏
        var enterFullScreen = function () {
            var doc = document.documentElement;
            if (doc.requestFullscreen) {
                doc.requestFullscreen();
            }
            else if (doc.mozRequestFullScreen) {
                // Firefox
                doc.mozRequestFullScreen();
            }
            else if (doc.webkitRequestFullscreen) {
                // Chrome, Safari, Opera
                doc.webkitRequestFullscreen();
            }
            else if (doc.msRequestFullscreen) {
                // IE/Edge
                doc.msRequestFullscreen();
            }
            //   isFullScreen.value = true;
        };
        // 退出全屏
        var exitFullScreen = function () {
            var doc = document;
            // 使用浏览器特定的 API
            if (doc.exitFullscreen) {
                doc.exitFullscreen();
            }
            else if (doc.mozCancelFullScreen) {
                // Firefox
                doc.mozCancelFullScreen();
            }
            else if (doc.webkitExitFullscreen) {
                // Chrome, Safari, Opera
                doc.webkitExitFullscreen();
            }
            else if (doc.msExitFullscreen) {
                // IE/Edge
                doc.msExitFullscreen();
            }
            //   isFullScreen.value = false;
        };
        // 监听全屏状态变化
        var onFullScreenChange = function () {
            var doc = document;
            if (doc.fullscreenElement ||
                doc.webkitFullscreenElement ||
                doc.mozFullScreenElement ||
                doc.msFullscreenElement) {
                isFullScreen.value = true;
            }
            else {
                isFullScreen.value = false;
            }
        };
        document.addEventListener("fullscreenchange", onFullScreenChange);
        document.addEventListener("webkitfullscreenchange", onFullScreenChange);
        document.addEventListener("mozfullscreenchange", onFullScreenChange);
        document.addEventListener("msfullscreenchange", onFullScreenChange);
        onMounted(function () {
            onFullScreenChange();
        });
        return function (_ctx, _cache) {
            var _component_CustomSVG = _resolveComponent("CustomSVG");
            var _component_n_icon = _resolveComponent("n-icon");
            var _component_n_button = _resolveComponent("n-button");
            var _component_n_tooltip = _resolveComponent("n-tooltip");
            return (_openBlock(), _createBlock(_component_n_tooltip, { trigger: "hover" }, {
                trigger: _withCtx(function () { return [
                    _createVNode(_component_n_button, {
                        quaternary: "",
                        class: "fullscreen-btn",
                        onClick: toggleFullScreen
                    }, {
                        icon: _withCtx(function () { return [
                            _createVNode(_component_n_icon, { size: '1.45rem' }, {
                                default: _withCtx(function () { return [
                                    _createVNode(_TransitionGroup, {
                                        tag: "fullscreen-btn-fades",
                                        name: "fullscreen-btn-fade"
                                    }, {
                                        default: _withCtx(function () { return [
                                            (isFullScreen.value)
                                                ? (_openBlock(), _createBlock(_component_CustomSVG, {
                                                    key: 0,
                                                    icon: "FullscreenExitOutlined"
                                                }))
                                                : (_openBlock(), _createBlock(_component_CustomSVG, {
                                                    key: 1,
                                                    icon: "FullscreenOutlined"
                                                }))
                                        ]; }),
                                        _: 1
                                    })
                                ]; }),
                                _: 1
                            })
                        ]; }),
                        _: 1
                    })
                ]; }),
                default: _withCtx(function () { return [
                    _createTextVNode(" " + _toDisplayString(isFullScreen.value ? "退出全屏" : "全屏"), 1)
                ]; }),
                _: 1
            }));
        };
    }
});
